export default __webpack_public_path__ + "static/media/go-card.4e15f83e.png";